import { Platform } from "expo-modules-core";
import { StyleSheet, View, type ViewProps } from "react-native";
import { Nothing } from "~/components/permission/Nothing";
import { useTheme } from "~/providers/ThemeProvider";

type ModalBackdropProps = {
    zIndex?: number;
} & Omit<ViewProps, "children">;

export const ModalBackdrop = ({ style, zIndex, ...viewProps }: ModalBackdropProps) => {
    const { colours } = useTheme();

    return Platform.select({
        web: <View {...viewProps} style={[styles.backdrop, { backgroundColor: colours.backdrop, zIndex }, style]} />,
        default: <Nothing />,
    });
};

const styles = StyleSheet.create({
    backdrop: {
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
    },
});
